module.exports = "/currency/assets/5ed8718fb98af92133c2aaa8e5ab7adf.png";